import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAnalytics } from './hooks/useAnalytics';
import {
  AnalyticsFiltersComponent,
  CallPerformanceMetricsCards,
  ConversationAnalyticsCards,
  AnalyticsTabs,
} from './components';
import { PageLoader, FullWidthContainer } from '../../components';

const Analytics: React.FC = () => {
  const { t } = useTranslation();
  const {
    filters,
    setFilters,
    callPerformance,
    conversationAnalytics,
    performanceMetrics,
    agentPerformance,
    callVolumeTrends,
    recentCalls,
    filtersData,
    loading,
    filterLoading,
    error,
    viewAgentDetails,
    updateUsageChart,
  } = useAnalytics();

  if (loading) {
    return <PageLoader show={true} />;
  }

  if (error) {
    return (
      <FullWidthContainer>
        <div className="space-y-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
              {t('analytics.title')}
            </h1>
            <p className="text-gray-600 dark:text-gray-400 mt-2">{t('analytics.subtitle')}</p>
          </div>
          <div className="flex items-center justify-center py-12">
            <div className="text-red-500 text-center">
              <p className="text-lg font-semibold">{t('common.error')}</p>
              <p className="text-sm">{error}</p>
            </div>
          </div>
        </div>
      </FullWidthContainer>
    );
  }

  return (
    <FullWidthContainer>
      <div className="space-y-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
              {t('analytics.title')}
            </h1>
            <p className="text-gray-600 dark:text-gray-400 mt-2">{t('analytics.subtitle')}</p>
          </div>
          {filterLoading && (
            <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-primary-500"></div>
              {t('common.loading')}
            </div>
          )}
        </div>

        <AnalyticsFiltersComponent
          filters={filters}
          filtersData={filtersData}
          onFiltersChange={setFilters}
        />

        <CallPerformanceMetricsCards metrics={callPerformance} />

        <ConversationAnalyticsCards analytics={conversationAnalytics} />
        <AnalyticsTabs
          performanceMetrics={performanceMetrics}
          agentPerformance={agentPerformance}
          callVolumeTrends={callVolumeTrends}
          recentCalls={recentCalls}
          onViewAgentDetails={viewAgentDetails}
          onUpdateUsageChart={updateUsageChart}
        />
      </div>
    </FullWidthContainer>
  );
};

export { Analytics };
